import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { MEDIA_REGISTRY } from "@app/shared/common/constants";

@Injectable({ providedIn: 'root' })
export class MediaRegisterService {
    constructor(
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer
    ) {
        this.init();
    }

    init() {
        MEDIA_REGISTRY.forEach((item) => {
            this.iconRegistry.addSvgIcon(
                item.name,
                this.sanitizer.bypassSecurityTrustResourceUrl(item.path)
            );
        });
    }
}